import { Action } from "../../../actions/actions";
import { Subsidiary } from "../../../types/types";
import { AuthActionTypes } from "../actions/actionTypes";

export function subsidiaries(state: Subsidiary[] = [], action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_SUBSIDIARIES_SUCCESS:
            return action.payload.subsidiaries.results;

        default:
            return state;
    }
}

export function subsidiariesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_SUBSIDIARIES:
            return true;

        case AuthActionTypes.GET_SUBSIDIARIES_SUCCESS:
        case AuthActionTypes.GET_SUBSIDIARIES_FAIL:
            return false;

        default:
            return state;
    }
}
